/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 11 to version 12
 * - Adds panelThickness field (null) to all islands for per-panel thickness overrides
 */

export const u12 = (blueprint: any): any => {
	console.log('schema-update:process-update:12:started');

	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 12;

		if (updatedBlueprint.kitchens?.children) {
			updatedBlueprint.kitchens.children.forEach((kitchen: any) => {
				const islands = kitchen.design?.islands?.children;
				if (!islands?.length) return;

				islands.forEach((island: any) => {
					if (island.panelThickness === undefined) {
						island.panelThickness = null;
					}
				});
			});
		}

		console.log('schema-update:process-update:12:completed');
		return updatedBlueprint;
	} catch (err) {
		console.error('schema-update:process-update:12:error', err);
		return null;
	}
};
